import { customAlphabet } from 'nanoid';

const alphabet = '0123456789ABCDEFGHJKMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';

export const newSnippetId = customAlphabet(alphabet, 10);
export const newHandoffId = customAlphabet(alphabet, 12);
